import { Navigate } from 'react-router-dom';
import { useSettingsContext } from 'context/settingsContext';
import PublicLayout from 'layout/PublicLayout';

const PublicRoute = () => {
    const settings = useSettingsContext();

    if (settings === null) return null;

    return settings?.project_public_enabled === 'true' ? <PublicLayout /> : <Navigate to="/login" replace />;
};

export default PublicRoute;
